/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateMailTemplateResponseData,
  CreateMailTemplateResponseDataFromJSON,
  CreateMailTemplateResponseDataFromJSONTyped,
  CreateMailTemplateResponseDataToJSON
} from './CreateMailTemplateResponseData'

/**
 *
 * @export
 * @interface GetMailTemplateResponse
 */
export interface GetMailTemplateResponse {
  /**
   *
   * @type {number}
   * @memberof GetMailTemplateResponse
   */
  status?: number
  /**
   *
   * @type {CreateMailTemplateResponseData}
   * @memberof GetMailTemplateResponse
   */
  data?: CreateMailTemplateResponseData
}

export function GetMailTemplateResponseFromJSON(json: any): GetMailTemplateResponse {
  return GetMailTemplateResponseFromJSONTyped(json, false)
}

export function GetMailTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMailTemplateResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateMailTemplateResponseDataFromJSON(json['data'])
  }
}

export function GetMailTemplateResponseToJSON(value?: GetMailTemplateResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateMailTemplateResponseDataToJSON(value.data)
  }
}
